export default "__VITE_ASSET__DYgAW4Yo__"